import gql from "graphql-tag";

export const GET_USER = gql`
    query User($userId: ID!){
        user(userId: $userId) {
            userId
            displayName
            email
            firstName
            lastName
            phoneNumber
            verified
            createdAt
            updatedAt
            roleList
            permissionList
        }
    }
`;

export const GET_MY_RESOURCES = gql`
    query UserResources($shareCategoryType: String, $shareCategoryId: ID){
        userResources(shareCategoryType: $shareCategoryType, shareCategoryId: $shareCategoryId) {
            accounts
            activities
            contacts
            projects
            tasks
        }
    }
`;

export const GET_USERS = gql`
    query Users($searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        users(searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            userId
            displayName
            email
            firstName
            lastName
            phoneNumber
            verified
            createdAt
            updatedAt
            roles {
                roleName
            }
        }
    }
`;

export const CREATE_USER = gql`
    mutation CreateUser($newUser: newUser!) {
        createUser(
            newUser: $newUser
        ) {
            userId
            displayName
            email
            firstName
            lastName
            phoneNumber
            verified
            createdAt
            updatedAt
            roleList
            permissionList
        }
    }
`;

export const UPDATE_USER = gql`
    mutation UpdateUser($changedUser: changedUser!) {
        updateUser(
            changedUser: $changedUser
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_USER = gql`
    mutation DeleteUser($deleteUserId: ID!) {
        deleteUser(
            deleteUserId: $deleteUserId
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_USERS = gql`
    mutation DeleteUsers($deleteUserIds: [ID!]!) {
        deleteUsers(
            deleteUserIds: $deleteUserIds
        ) {
            returnCode
            message
        }
    }
`;

export const SEND_VERIFICATION = gql`
    mutation SendVerification($userId: ID!) {
        sendVerification(
            userId: $userId
        ) {
            returnCode
            message
            userVerificationId
            verificationCode
        }
    }
`;

export const CHECK_VERIFICATION_CODE = gql`
    mutation CheckVerificationCode($userId: ID!, $userVerificationId: ID!, $verificationCode: String!) {
        checkVerificationCode(
            userId: $userId
            userVerificationId: $userVerificationId
            verificationCode: $verificationCode
        ) {
            returnCode
            message
        }
    }
`;
